import React, { useState } from 'react';
import { formatCycleRange } from '../utils';

const MIN_VISIBLE_CYCLES = 6;

export function CycleRangeTimeline({ fromCycle, toCycle, onChange }) {
  const [pendingFrom, setPendingFrom] = useState(null);

  const from = fromCycle == null || fromCycle === '' ? 1 : Number(fromCycle);
  const to =
    toCycle === '' || toCycle === null || toCycle === undefined
      ? null
      : Number(toCycle);

  const maxCycle = Math.max(MIN_VISIBLE_CYCLES, from, to || 0);
  const cycles = Array.from({ length: maxCycle }, (_, i) => i + 1);

  const isHighlighted = (value) => value >= from && (to === null || value <= to);
  const infinityHighlighted = to === null;

  const handleCycleClick = (value) => {
    if (pendingFrom === null) {
      onChange(value, value);
      setPendingFrom(value);
    } else {
      onChange(Math.min(pendingFrom, value), Math.max(pendingFrom, value));
      setPendingFrom(null);
    }
  };

  const handleInfinityClick = () => {
    if (pendingFrom === null) {
      onChange(from, null);
    } else {
      onChange(pendingFrom, null);
      setPendingFrom(null);
    }
  };

  return (
    <div>
      <div
        role="group"
        aria-label="Ciclos em que o desconto se aplica"
        style={{ display: 'flex', alignItems: 'center' }}
      >
        {cycles.map((value, i) => {
          const nextHighlighted =
            i === cycles.length - 1
              ? infinityHighlighted
              : isHighlighted(value + 1);
          const lineGreen = isHighlighted(value) && nextHighlighted;

          return (
            <React.Fragment key={value}>
              <button
                type="button"
                onClick={() => handleCycleClick(value)}
                title={`Ciclo ${value}`}
                aria-pressed={isHighlighted(value)}
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  border: isHighlighted(value)
                    ? 'none'
                    : 'var(--stroke-small) solid var(--border-neutral-default)',
                  background: isHighlighted(value)
                    ? 'var(--bg-brand-default)'
                    : 'var(--bg-neutral-layer01)',
                  color: isHighlighted(value)
                    ? 'var(--fg-neutral-subtler)'
                    : 'var(--fg-neutral-default)',
                  fontFamily: 'inherit',
                  fontWeight: 'var(--fw-medium)',
                  fontSize: 'var(--fs-14)',
                  cursor: 'pointer',
                  flexShrink: 0,
                }}
              >
                {value}
              </button>
              <div
                style={{
                  width: '16px',
                  height: '2px',
                  background: lineGreen
                    ? 'var(--bg-brand-default)'
                    : 'var(--border-neutral-default)',
                  flexShrink: 0,
                }}
              />
            </React.Fragment>
          );
        })}
        <button
          type="button"
          onClick={handleInfinityClick}
          title="Sem data de término"
          aria-pressed={infinityHighlighted}
          style={{
            padding: '0 10px',
            height: '32px',
            borderRadius: '16px',
            border: infinityHighlighted
              ? 'none'
              : 'var(--stroke-small) dashed var(--border-neutral-default)',
            background: infinityHighlighted
              ? 'var(--bg-brand-default)'
              : 'var(--bg-neutral-layer01)',
            color: infinityHighlighted
              ? 'var(--fg-neutral-subtler)'
              : 'var(--fg-neutral-default)',
            fontFamily: 'inherit',
            fontWeight: 'var(--fw-medium)',
            fontSize: 'var(--fs-14)',
            cursor: 'pointer',
            flexShrink: 0,
          }}
        >
          ∞ Sem fim
        </button>
      </div>
      {pendingFrom !== null && (
        <small
          className="text-muted"
          style={{ display: 'block', marginTop: 'var(--space-4)' }}
        >
          Agora clique no ciclo final (ou em ∞ pra sem fim)
        </small>
      )}
      <div
        style={{
          marginTop: 'var(--space-8)',
          fontSize: 'var(--fs-14)',
          fontWeight: 'var(--fw-medium)',
          color: 'var(--fg-brand-strong)',
        }}
      >
        Vigência: {formatCycleRange(from, to)}
      </div>
    </div>
  );
}
